import { get } from 'lodash'
import { IShipmentStates } from 'types/graphqlTypes'
import { SHIPMENT_STATE_LABELS } from 'apps/marketplace/pages/shipment-details/components/Header/ShipmentInfo/types'

export const getLocationTextByStatus = (
  state: string,
  facilityName: string,
  shipmentState: IShipmentStates | undefined,
  stopName: string,
  showMissingTrailers: boolean
) => {
  if (state === 'assigned_to_facility') {
    return `@ ${facilityName}`
  }
  if (state === 'assigned_to_shipment' || showMissingTrailers) {
    const stateLabel = get(SHIPMENT_STATE_LABELS, shipmentState || '', '')
    if (
      shipmentState &&
      [IShipmentStates.in_transit, IShipmentStates.dispatched].includes(shipmentState)
    ) {
      return `${stateLabel} to ${stopName}`
    }
    return stateLabel
  }
  if (state === 'empty_at_delivery') {
    return `Empty @ ${stopName}`
  }
  if (state === 'unassigned') {
    return 'Not assigned'
  }
  if (state === 'inactive') {
    return 'Out of Service'
  }

  return 'N/A'
}
